import { WatchfaceDeviceType } from '@/hooks';
import { ElectronApi } from '@/services/electron.api';
import { GlobalConfig } from '@/services/gloabl.config';
import { round } from 'lodash-es';

export const validBinSize = async (data: {
  binFile: string;
  deleteIfOverSize: boolean;
  deviceType: WatchfaceDeviceType;
  maxBinLimit?: number;
}) => {
  const { binFile, deleteIfOverSize, deviceType, maxBinLimit } = data;
  if (!GlobalConfig.validWatchfaceBin.includes(deviceType)) return;
  if (!maxBinLimit) return;

  const fs = ElectronApi.fs;
  const path = ElectronApi.path;
  if (!fs || !path) return;

  // 获取表盘文件大小
  let isOver = false;
  try {
    const stat = await fs.promises.stat(binFile);
    const binSize = round(stat.size / 1024, 2);
    isOver = binSize > maxBinLimit;
    return {
      isOver,
      maxBinLimit,
      binSize
    };
  } catch (error) {
    console.log(error);
  } finally {
    if (deleteIfOverSize && isOver) {
      fs.promises.rm(binFile, { force: true });
    }
  }
};
